import React from 'react';
import { Chip } from '@mui/material';
import { Tag as TagIcon } from '@mui/icons-material';

interface TagsArrayProps {
	tags: any[];
	changeFilter?: (name: string, operator: string, value: number[] | null) => void;
}

function TagsArray({ tags, changeFilter }: TagsArrayProps) {
	return tags ? (
		tags.map(tag => (
			<Chip
				key={tag.tags_id}
				className="m-2 max-w-full rounded-4"
				label={tag.tags_title}
				icon={<TagIcon />}
				variant="outlined"
				size="small"
				onClick={() => {
					if (changeFilter) changeFilter('tagd_tags_id', 'in', [tag.tags_id]);
				}}
			/>
		))
	) : (
		<></>
	);
}

export default React.memo(TagsArray);
